/* eslint-disable react/prop-types */
import classes from "./detail.module.scss";

import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import Grid from "@/components-library/layout/grid";
import FileInput from "@/components-library/widgets/file-input";
import TextArea from "@/components-library/widgets/text-area";
import SelectableList from "@/components-library/widgets/selectable-list";

function Deatil({
  beneficiaries,
  selectedBeneficiary,
  onBeneficiarySelect,
  outgoings,
  selectedOutgoing,
  onOutgoingSelect,
  types,
  selectedType,
  onTypeSelect,
  onPromotingChange,
  onGrantedChange,
  onNotesChange,
  sectors,
  selectedSector,
  onSectorSelect,
  onMaxContributionChange,
  onTechnicalDocumentUpload,
  techinaclFileInfo,
  isBeneficiaryValid,
  isOutgoingsValid,
  isTypeValid,
  isSectorValid,
  isNotesValid,
  isGrantedValid,
  isPromotigValid,
  isTechinaclFileInfoValid,
  isMaxContributionValid,
  incentives,
  isIncentiveValid,
  selectedIncentive,
  onIncentiveSelect,
  announcement,
}) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="center"
      className={classes.infoContainer}
    >
      <Label
        tag="h6"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.subTitle}
      >
        Dettagli
      </Label>
      <Grid columns="1fr 1fr 1fr">
        <SelectableList
          title="Beneficiari"
          list={beneficiaries}
          value={selectedBeneficiary}
          onItemSelect={onBeneficiarySelect}
          isEnabled={true}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isBeneficiaryValid,
          })}
          titleClassName={classes.titleList}
        />
        <SelectableList
          title="Spese finanziate"
          list={outgoings}
          value={selectedOutgoing}
          onItemSelect={onOutgoingSelect}
          isEnabled={true}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isOutgoingsValid,
          })}
          titleClassName={classes.titleList}
        />
        <SelectableList
          title="Tipologia agevolazione"
          list={types}
          value={selectedType}
          onItemSelect={onTypeSelect}
          isEnabled={true}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isTypeValid,
          })}
          titleClassName={classes.titleList}
        />
      </Grid>
      <Grid columns="1fr 1fr 1fr">
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea, {
            [classes.valid]: isPromotigValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Ente promotore
          </Label>
          <TextArea
            name="Title"
            rows={4}
            onChange={onPromotingChange}
            defaultValue={announcement?.promoting}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea, {
            [classes.valid]: isGrantedValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Agevolazione prevista
          </Label>
          <TextArea
            name="Title"
            rows={4}
            onChange={onGrantedChange}
            defaultValue={announcement?.granted}
          />
        </Flex>
        <SelectableList
          title="Istruttoria"
          list={incentives}
          value={selectedIncentive}
          onItemSelect={onIncentiveSelect}
          isEnabled={true}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isIncentiveValid,
          })}
          titleClassName={classes.titleList}
        />
      </Grid>
      <Grid columns="1fr 1fr 1fr">
        <SelectableList
          title="Settore"
          list={sectors}
          value={selectedSector}
          onItemSelect={onSectorSelect}
          isEnabled={true}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isSectorValid,
          })}
          titleClassName={classes.titleList}
        />

        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea, {
            [classes.valid]: isMaxContributionValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Max. contributo ottenibile
          </Label>
          <TextArea
            name="Title"
            rows={4}
            onChange={onMaxContributionChange}
            defaultValue={announcement?.maxContribution}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea, {
            [classes.valid]: isNotesValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Note importanti
          </Label>
          <TextArea
            name="Title"
            rows={4}
            onChange={onNotesChange}
            defaultValue={announcement?.notes}
          />
        </Flex>
      </Grid>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classNames(classes.textField, {
          [classes.valid]: isTechinaclFileInfoValid,
        })}
      >
        <Label tag="p" size="md" align="start" color="secondary">
          Scheda Tecnica
        </Label>
        <FileInput
          label=""
          name="file"
          fileName={techinaclFileInfo?.name}
          accept=".pdf"
          onFileUpload={onTechnicalDocumentUpload}
        />
      </Flex>
    </Flex>
  );
}

export default Deatil;
